/**
 * @generated SignedSource<<6ee277a7f3efd81375d34e7d94158cd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainPreventDefault_todo$data = {
  readonly canChangeStatus: boolean;
  readonly category: {
    readonly title: string;
  } | null;
  readonly id: string;
  readonly response: {
    readonly __typename: string;
  } | null;
  readonly status: TodoStatus;
  readonly subTodos: ReadonlyArray<{
    readonly __typename: "Todo";
    readonly status: TodoStatus;
  }> | null;
  readonly " $fragmentType": "TodoEditNewMainPreventDefault_todo";
};
export type TodoEditNewMainPreventDefault_todo$key = {
  readonly " $data"?: TodoEditNewMainPreventDefault_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainPreventDefault_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainPreventDefault_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canChangeStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "924a477e38da1708be89e7c826528009";

export default node;
